import React from "react";
import { Box, Container, Grid, Typography, Stack } from "@mui/material";

/**
 * The section the home page was missing.
 *
 * "Key Features" told a visitor what the software has; nothing told them what actually happens if
 * they say yes. For an organizer weighing whether to move their event off a spreadsheet, the sequence
 * is the reassurance: particularly that setup is not their problem and that money arrives at the end.
 *
 * Each step is a claim the product genuinely makes elsewhere (the FAQ, pricing and llms.txt all say
 * the same things), so this reads as a summary rather than a separate set of promises.
 */
const steps = [
  {
    title: "Tell us about your event",
    body: "Get in touch and we set your merit badge college up for you, including its own web address at your-event.badgereg.com. You do not install anything.",
  },
  {
    title: "Load your class schedule",
    body: "Add your merit badge classes, session times, counselors, capacity limits, age restrictions and prerequisites. Run multiple sessions of the popular badges.",
  },
  {
    title: "Parents register and pay online",
    body: "Families sign up, add each of their Scouts, pick classes around a schedule that will not double-book them, and pay by card or PayPal at checkout.",
  },
  {
    title: "Run the day and close the books",
    body: "Take attendance, watch registrations in real time, export your roster and transaction ledger, and receive the proceeds after the event.",
  },
];

const HowItWorks = () => {
  return (
    <Box sx={{ backgroundColor: "background.default", py: { xs: 5, md: 8 } }}>
      <Container maxWidth="lg">
        <Typography
          variant="h4"
          component="h2"
          align="center"
          sx={{ fontWeight: "bold", mb: 1 }}
        >
          How it works
        </Typography>
        <Typography
          align="center"
          color="text.secondary"
          sx={{ mb: { xs: 3, md: 5 } }}
        >
          From first email to funds in your unit's account.
        </Typography>
        <Grid container spacing={{ xs: 3, md: 4 }}>
          {steps.map((step, index) => (
            <Grid item xs={12} sm={6} md={3} key={step.title}>
              <Stack spacing={1.5}>
                <Box
                  aria-hidden="true"
                  sx={{
                    width: 44,
                    height: 44,
                    borderRadius: "50%",
                    backgroundColor: "primary.main",
                    color: "primary.contrastText",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: 700,
                    fontSize: "1.125rem",
                  }}
                >
                  {index + 1}
                </Box>
                <Typography
                  variant="h6"
                  component="h3"
                  sx={{ fontWeight: "bold" }}
                >
                  {step.title}
                </Typography>
                <Typography color="text.secondary" sx={{ lineHeight: 1.7 }}>
                  {step.body}
                </Typography>
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default HowItWorks;
